import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from 'framer-motion';

const slides = [
  {
    image: 'https://plus.unsplash.com/premium_photo-1716758706817-d096025c1290?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'Slide 1',
    description: 'The power of para-athletics is not just in the medals, but in the message: Nothing is impossible.'
  },
  {
    image: 'https://images.unsplash.com/photo-1544045368-9499a6d0eefb?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'Slide 2',
    description: 'Champions are not born — they are built through resilience, sweat, and relentless spirit.'
  },
  {
    image: 'https://plus.unsplash.com/premium_photo-1669592562678-764eb8baf54d?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'Slide 3',
    description: 'We don’t wait for opportunities — we create them on the track, on the field, and in life.'
  },
  {
    image: 'https://plus.unsplash.com/premium_photo-1716896945217-1a7faa3ec00a?q=80&w=1648&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'Slide 4',
    description: 'In para-athletics, every challenge is an opportunity, every step is a victory.'
  }
];



function Banner() {

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{ ...style, display: "block" }}
            onClick={onClick}
          />
        );
    }
    
    function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
        />
    );
    }

    var settings = {
        dots: false,
        fade: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
    }
  return (
    <div className="slider-container bannerSection">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="bannerSectionWrap">
            <img
              src={slide.image}
              alt={slide.title}
              className="bannerImage"
            />
            <motion.div 
              initial={{ opacity: 0, y: 20 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8 }}
              className="bannerContentWrap"
            >
              {/* <motion.h2 
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="bannerContentHeading"
              >
                {slide.title}
              </motion.h2> */}
              <motion.p 
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="bannerContentText"
              >
                "{slide.description}"
              </motion.p>
            </motion.div>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default Banner
